<template>
  <div class="card">
    <div class="card-info-top">
      <span class="left">{{cardName}}</span>
      <span class="right">有效期至{{cardExpiredDate}}</span>
    </div>
    <div class="card-info-bottom">
      <span class="left">No.{{cardNo}}</span>
      <div class="right">
        <span class="small">余额</span>
        <span class="big">￥{{cardBalance}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "giftcard",
  props: {
    cardNo: {
      type: String,
      default: ""
    },
    cardExpiredDate: {
      type: String,
      default: ""
    },
    cardName: {
      type: String,
      default: ''
    },
    cardBalance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  height: 100px;
  width: 100%;
  padding: 10px;
  background: url(~@assets/img/app/my/gift_card.jpg);
  background-size: 100% 100%;
  box-shadow: 0px 5px 20px #666666; // 阴影
  .card-info-top {
    display: flex;
    align-items:baseline;
    .left {
      width: 190px;
      // color: #ecc697;
      font-size: 16px;
      font-weight: 600;
    }
    .right {
      // color: #9e8870;
      color: white;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .card-info-bottom {
    display: flex;
    align-items:baseline;
    .left {
      width: 190px;
      font-size: 12px;
      font-weight: 400;
    }
    .right {
      flex: 1;
      display: flex;
      align-items: baseline;
      .small{
        color: white;
        font-size: 14px; 
        font-weight: 400;
      }
      .big {
        color: white;
        font-size: 24px; 
        font-weight: 700;
      }
    }
  }
}
</style>


